




































































import { Component, Vue } from 'vue-property-decorator'
import LoginCard from '@/components/layout/LoginCard.vue'


@Component({
    components: {
        LoginCard
    }
})
export default class Layout extends Vue {
    appVersion = APP_VERSION
    loading = false
    drawer = false

    get isLoggedIn(): boolean {
        return !!this.$store.state.authKey
    }

    get username(): string {
        return this.$store.state.authUsername as string
    }
}
